// Submit Monthly Collection Constants
export const SUBMIT_MONTHLY_COLLECTION_REQUEST = 'SUBMIT_MONTHLY_COLLECTION_REQUEST'
export const SUBMIT_MONTHLY_COLLECTION_SUCCESS = 'SUBMIT_MONTHLY_COLLECTION_SUCCESS'
export const SUBMIT_MONTHLY_COLLECTION_FAIL = 'SUBMIT_MONTHLY_COLLECTION_FAIL'
export const SUBMIT_MONTHLY_COLLECTION_RESET = 'SUBMIT_MONTHLY_COLLECTION_RESET'

// Get My Monthly Collections Constants
export const GET_MY_MONTHLY_COLLECTIONS_REQUEST = 'GET_MY_MONTHLY_COLLECTIONS_REQUEST'
export const GET_MY_MONTHLY_COLLECTIONS_SUCCESS = 'GET_MY_MONTHLY_COLLECTIONS_SUCCESS'
export const GET_MY_MONTHLY_COLLECTIONS_FAIL = 'GET_MY_MONTHLY_COLLECTIONS_FAIL'
export const GET_MY_MONTHLY_COLLECTIONS_RESET = 'GET_MY_MONTHLY_COLLECTIONS_RESET'

// Get My Monthly Statistics Constants
export const GET_MY_MONTHLY_STATISTICS_REQUEST = 'GET_MY_MONTHLY_STATISTICS_REQUEST'
export const GET_MY_MONTHLY_STATISTICS_SUCCESS = 'GET_MY_MONTHLY_STATISTICS_SUCCESS'
export const GET_MY_MONTHLY_STATISTICS_FAIL = 'GET_MY_MONTHLY_STATISTICS_FAIL'
export const GET_MY_MONTHLY_STATISTICS_RESET = 'GET_MY_MONTHLY_STATISTICS_RESET'

// Update Monthly Collection Constants
export const UPDATE_MONTHLY_COLLECTION_REQUEST = 'UPDATE_MONTHLY_COLLECTION_REQUEST'
export const UPDATE_MONTHLY_COLLECTION_SUCCESS = 'UPDATE_MONTHLY_COLLECTION_SUCCESS'
export const UPDATE_MONTHLY_COLLECTION_FAIL = 'UPDATE_MONTHLY_COLLECTION_FAIL'
export const UPDATE_MONTHLY_COLLECTION_RESET = 'UPDATE_MONTHLY_COLLECTION_RESET'

// Delete Monthly Collection Constants
export const DELETE_MONTHLY_COLLECTION_REQUEST = 'DELETE_MONTHLY_COLLECTION_REQUEST'
export const DELETE_MONTHLY_COLLECTION_SUCCESS = 'DELETE_MONTHLY_COLLECTION_SUCCESS'
export const DELETE_MONTHLY_COLLECTION_FAIL = 'DELETE_MONTHLY_COLLECTION_FAIL'
export const DELETE_MONTHLY_COLLECTION_RESET = 'DELETE_MONTHLY_COLLECTION_RESET'


export const GET_PROCESS_DEFAULTS_RESET = 'GET_PROCESS_DEFAULTS_RESET';